import styled from "styled-components";

interface MainPostItemStyleProps {
  $tagColor?:
    | "Green"
    | "Orange"
    | "Purple"
    | "SkyBlue"
    | "Blue"
    | "Yellow"
    | "Pink";
}

export const MainPostItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  padding: 16px;
  border-radius: 16px;
  gap: 16px;
`;

export const PostItemBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PostCategory = styled.div<MainPostItemStyleProps>`
  display: flex;
  width: fit-content;
  padding: 4px 6px;
  color: ${(props) => props.theme.colors["tag" + props.$tagColor + "100"]};
  font-size: 1.1rem;
  font-weight: 400;
  font-family: "Pretendard";
  background-color: ${(props) =>
    props.theme.colors["tag" + props.$tagColor + "20"]};
  border-radius: 5px;
`;

export const PostTitBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PostTitle = styled.h4`
  font-size: 1.5rem;
  font-weight: 500;
  font-family: "Pretendard";
`;

export const PostContent = styled.p`
  width: 100%;
  color: ${(props) => props.theme.colors.black40};
  font-size: 1.4rem;
  font-weight: 300;
  font-family: "Pretendard";
  line-height: 140%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PostInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UserProfileImg = styled.div`
  overflow: hidden;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #d9d9d9;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const Info = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.black30};
  font-size: 1.2rem;
  font-weight: 300;
  font-family: "Pretendard";
  flex-direction: column;
  gap: 2px;

  span {
    color: ${(props) => props.theme.colors.black100};
    font-size: 1.3rem;
  }
`;

export const PostReactionList = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

export const PostReactionItem = styled.div`
  display: flex;
  padding: 4px 6px;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-family: "Pretendard";
  line-height: 14px;
  background: ${(props) => props.theme.colors.black5};
  border-radius: 5px;
  align-items: center;
  gap: 3px;

  svg {
    width: 18px;
    height: 18px;
  }
`;
